module.exports = __webpack_public_path__ + "img/cross.46ee37d2.svg";